import { useState } from "react";
import AlertBox from "../../components/AlertBox";
import MainLayout from "../../components/layouts/MainLayout";
import Box from "../../components/Box";
import { Modal } from "react-bootstrap";
import { RequiredAsterisk } from "../../components/FormHelper";
import { useCustomerSearch } from "../../utils/customer/CustomerSearchUtil";
import { CustomerActiveBadge } from "../../components/customer/CustomerBadge";
import { reactivateCustomer } from "../../api/customer";

export default function ReactivateCustomerPage() {
  const [alert, setAlert] = useState({ show: false, message: "", type: "" });
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({ oldsearch: "", newsearch: "" });
  const {
    data: oldCustomer,
    loading: loadingOldCustomer,
    error: errorOldCustomer,
    searchCustomer: searchOldCustomer,
    resetData: resetOldSearch,
  } = useCustomerSearch();

  const {
    data: newCustomer,
    loading: loadingNewCustomer,
    error: errorNewCustomer,
    searchCustomer: searchNewCustomer,
    resetData: resetNewSearch,
  } = useCustomerSearch();

  const onSubmitOld = (event) => {
    event.preventDefault();
    searchOldCustomer({ q: form.oldsearch, type: "old" });
  };

  const onSubmitNew = (event) => {
    event.preventDefault();
    searchNewCustomer({ q: form.newsearch, type: "new" });
  };

  const onSuccess = (message) => {
    setForm({ oldsearch: "", newsearch: "" });
    resetOldSearch();
    resetNewSearch();
    setAlert({ show: true, message: message, type: "success" });
  };

  return (
    <MainLayout resource_key="manage-customer">
      <div className="container-fluid">
        <h1 className="h3 mb-4 text-gray-800">Reaktivasi Pelanggan</h1>
        <AlertBox {...alert} setAlert={setAlert} />

        <div className="row">
          <div className="col-md col-12">
            <form className="w-100" onSubmit={(event) => onSubmitOld(event)}>
              <div className="row">
                <div className="col">
                  <div className="form-group">
                    <label htmlFor="">Nomor Registrasi Lama</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Masukan Nomor Registrasi Lama ..."
                      value={form.oldsearch}
                      onChange={(event) => setForm({ ...form, oldsearch: event.target.value })}
                    />
                  </div>
                </div>
                <div className="col-auto d-flex align-items-end pb-3">
                  <button className="btn btn-primary" disabled={loadingOldCustomer}>
                    {loadingOldCustomer ? "Mencari ..." : "Cek Nomor"}
                  </button>
                </div>
              </div>
            </form>

            {oldCustomer === null && !errorOldCustomer && !loadingOldCustomer && (
              <div className="alert alert-info">Masukan nomor registrasi lama terlebih dahulu</div>
            )}
            {errorOldCustomer && <div className="alert alert-danger">{errorOldCustomer}</div>}

            {loadingOldCustomer && (
              <div className="card mb-3">
                <div className="card-body">Mencari pelanggan lama ...</div>
              </div>
            )}

            {oldCustomer !== null && (
              <Box title="Data Registrasi Terdahulu">
                <CustomerDetailsBoxContent customerData={oldCustomer} />
              </Box>
            )}
          </div>

          <div className="col-md-auto d-none d-md-flex align-items-center text-secondary">
            <h1>
              <i className="fa fa-arrow-right"></i>
            </h1>
          </div>

          <div className="col-md col-12">
            <form className="w-100" onSubmit={(event) => onSubmitNew(event)}>
              <div className="row">
                <div className="col">
                  <div className="form-group">
                    <label htmlFor="">Nomor Registrasi Baru</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Masukan Nomor Registrasi Baru ..."
                      value={form.newsearch}
                      onChange={(event) => setForm({ ...form, newsearch: event.target.value })}
                    />
                  </div>
                </div>
                <div className="col-auto d-flex align-items-end pb-3">
                  <button className="btn btn-primary">Cek Nomor</button>
                </div>
              </div>
            </form>

            {newCustomer === null && !errorNewCustomer && !loadingNewCustomer && (
              <div className="alert alert-info">Masukan nomor registrasi baru terlebih dahulu</div>
            )}
            {errorNewCustomer && <div className="alert alert-danger">{errorNewCustomer}</div>}

            {loadingNewCustomer && (
              <div className="card mb-3">
                <div className="card-body">Mencari pelanggan baru ...</div>
              </div>
            )}

            {newCustomer !== null && (
              <Box title="Data Registrasi Sekarang">
                <CustomerDetailsBoxContent customerData={newCustomer} />
              </Box>
            )}
          </div>
        </div>

        <div className="d-flex justify-content-end">
          {oldCustomer !== null && newCustomer !== null && (
            <button className="btn btn-success btn-lg" onClick={() => setModal("confirm")}>
              <i className="fa fa-check"></i> Reaktivasi Pelanggan
            </button>
          )}
        </div>
      </div>

      <ModalConfirmation
        show={modal === "confirm"}
        old_registration={oldCustomer}
        new_registration={newCustomer}
        onSuccess={onSuccess}
        onClose={() => setModal(null)}
      />
    </MainLayout>
  );
}

function CustomerDetailsBoxContent({ customerData }) {
  return (
    <>
      <div className="form-group row">
        <label className="col-sm-4 col-form-label font-weight-bold">No. Registrasi:</label>
        <div className="col-sm-8 d-flex align-items-center">
          <div className="">{customerData.registration?.registration_number}</div>
        </div>
      </div>
      <div className="form-group row">
        <label className="col-sm-4 col-form-label font-weight-bold">Nama Pelanggan:</label>
        <div className="col-sm-8 d-flex align-items-center">
          <div className="">{customerData.name}</div>
        </div>
      </div>
      <div className="form-group row">
        <label className="col-sm-4 col-form-label font-weight-bold">Status:</label>
        <div className="col-sm-8 d-flex align-items-center">
          <div className="">
            <CustomerActiveBadge status={customerData.is_active} />
          </div>
        </div>
      </div>
      <div className="form-group row">
        <label className="col-sm-4 col-form-label font-weight-bold">Nomor Handphone:</label>
        <div className="col-sm-8 d-flex align-items-center">
          <div className="">{customerData.phone_number}</div>
        </div>
      </div>
      <div className="form-group row">
        <label className="col-sm-4 col-form-label font-weight-bold">No. Pelanggan:</label>
        <div className="col-sm-8 d-flex align-items-center">
          <div className="">{customerData.customer_number}</div>
        </div>
      </div>
      <div className="form-group row">
        <label className="col-sm-4 col-form-label font-weight-bold">Alamat:</label>
        <div className="col-sm-8 d-flex align-items-center">
          <div className="">{customerData.address}</div>
        </div>
      </div>
      <div className="form-group row">
        <label className="col-sm-4 col-form-label font-weight-bold">Paket Internet:</label>
        <div className="col-sm-8 d-flex align-items-center">
          <div className="">{customerData.internet_package.name}</div>
        </div>
      </div>
      <div className="form-group row">
        <label className="col-sm-4 col-form-label font-weight-bold">Project:</label>
        <div className="col-sm-8 d-flex align-items-center">
          <div className="">{customerData.project?.name || "-"}</div>
        </div>
      </div>
    </>
  );
}

function ModalConfirmation({ show, old_registration, new_registration, onSuccess, onClose }) {
  const [alert, setAlert] = useState({ show: false, message: "", type: "" });
  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({ note: "" });

  const handleClose = () => {
    setForm({ note: "" });
    onClose();
  };

  const reactivateCustomerAction = async (event) => {
    event.preventDefault();

    const formData = {
      old_customer_id: old_registration.id,
      new_customer_id: new_registration.id,
      note: form.note,
    };

    setLoading(true);
    try {
      let { data } = await reactivateCustomer({ ...formData });
      handleClose();
      onSuccess(data.message);
    } catch (error) {
      let message = "";
      if (error.response) {
        let { data } = error.response;
        message = data.message;
      } else {
        message = "Something Error Happened";
      }
      setAlert({ show: true, message: message, type: "danger" });
    }
    setLoading(false);
  };

  return (
    <Modal show={show} onHide={() => handleClose()}>
      <Modal.Header closeButton>
        <Modal.Title>Konfirmasi Reaktivasi</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Apakah anda yakin untuk mereaktivasi {old_registration?.registration?.registration_number}{" "}
          ke {new_registration?.registration?.registration_number}?
        </p>
        <AlertBox {...alert} setAlert={setAlert} />
        <form onSubmit={(event) => reactivateCustomerAction(event)}>
          <div className="form-group">
            <label>
              Alasan
              <RequiredAsterisk />{" "}
            </label>
            <textarea
              className="form-control"
              required
              value={form.note}
              onChange={(event) => setForm({ ...form, note: event.target.value })}
            ></textarea>
          </div>
          <div className="form-group">
            <button className="btn btn-primary mr-2" type="submit" disabled={loading}>
              {loading ? "Mereaktivasi1" : "Ya, Saya Yakin"}
            </button>
            <button className="btn btn-secondary" type="button" onClick={() => handleClose()}>
              Batal
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
}
